<!-- eslint-disable -->
<template>
  <div id="borrowerInfoQuestion" :data-cy-id="question.id">
    <div class="justify-content-start">
      <div v-if="singleForm || showSingleForm" class="col-12" :class="'single-form mx-auto py-2 borrower-attribute ba-' + classQuestionId + '-container'">
          <!-- <div v-if="!isBorrowerAttribute" class="biq-name">
          <label :for="'biq' + classQuestionId">
            <span>{{ question.directiveMapping.label }}</span>
          </label>
        </div> -->
        <div class="biq-type-container" v-if="!isBorrowerAttribute">
          <component
            :is="currentView"
            :question="question"
            :key="classQuestionId"
            :disabled="false"
            :errorText="errorText"
            @invalidity="$emit('invalidity', $event)"
            @answer="onAnswer">
          </component>
        </div>
        <div v-if="isBorrowerAttribute" class="basic-info-attribute">
          <component
            :is="currentView"
            :onBasicInfo="true"
            :question="question.attributes[0]"
            :errorText="errorText"
            @invalidity="$emit('invalidity', $event)"
            @answer="onAnswer"
            :disabled="false">
          </component>
        </div>
      </div>
      <div v-else class="col-12" :class="'borrower-attribute ba-' + classQuestionId + '-container'">
        <div v-if="!isBorrowerAttribute" class="marketplace-content">
          <component
            :is="currentView"
            :question="question"
            :key="classQuestionId"
            :disabled="false"
            :customButton="customButton"
            @answer="onAnswer">
          </component>
        </div>
        <div v-if="isBorrowerAttribute" class="marketplace-content">
          <component
            :is="currentView"
            :onBasicInfo="true"
            :question="question.attributes[0]"
            :customButton="customButton"
            @answer="onAnswer"
            :disabled="false"
            :v="v"
          >
          </component>
        </div>
      </div>
    </div>

    <QuestionNav
      :submitButton="{
        btnText: 'Next',
        disabled: disableNext,
      }"
      v-if="!singleForm && !showSingleForm"
      :customButton="customButton"
      :submitting="submitting || transitioning"
      @submit="onSubmit(question, attributes)"
      @customAction="onCustomAction()"
    />
  </div>
</template>

<script>
import QuestionNav from "~/components/marketplace/subComponents/QuestionNav"
import { mapState } from 'pinia'
import { useQuestionsStore } from '~/store/questions'
import BorrowerAttribute from '../borrowerAttributes/BorrowerAttribute'
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import { useVuelidate } from '@vuelidate/core'
import {required, requiredIf} from '@vuelidate/validators'
export default {
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  props: {
    disabled: Boolean,
    isNotFirstQuestion: Boolean,
    question: Object,
    submitting: Boolean,
    transitioning: Boolean,
    v: Object,
    showSingleForm: Boolean
  },
  emits: ['invalidity', 'submit', 'previousQuestion', 'nextQuestion'],
  data () {
    return {
      attributes: [],
      questionInvalid: {},
      invalidPage: null,
      errorMessage: 'Some fields are invalid',
      customButtonClicked: false,
      mounted: false,
    }
  },
  created() {
    this.$watch('v$.$invalid', (invalid) => {
      this.$emit('invalidity', invalid)
    }, {immediate: true})
  },
  computed: {
    ...mapState(useQuestionsStore, {
      singleForm: store => get(store, 'singleForm'),
    }),
    currentView () {
      switch (this.question.directiveMapping.directive) {
        case 'biq-bool-icons':
          return resolveComponent('BasicInfoQuestionBooleanIcons')
        case 'biq-multi-select':
          return resolveComponent('BasicInfoQuestionMultiSelect')
        case 'biq-select':
          return resolveComponent('BasicInfoQuestionSelect')
        default:
          return resolveComponent('borrower-attribute')
      }
    },
    errorText() {
      let errorTxt = ''
      if (this.v$.value.$error && this.question.alias === 'borrower.stateId') {
        errorTxt = 'Please select a state'
      } else if (this.v$.value.$error && this.question.alias === 'businessType') {
        errorTxt = 'Please select a business type'
      } else if (this.v$.value.$error) {
        errorTxt = 'Please select a value'
      }
      return errorTxt
    },
    isBorrowerAttribute () {
      switch (this.question.directiveMapping.directive) {
        case 'biq-bool-icons':
        case 'biq-multi-select':
        case 'biq-select':
          return false
        default:
          return true
      }
    },
    classQuestionId () {
      return this.question ? String(this.question.id).replace(/\./g, '-') : ''
    },
    disableNext () {
      const questionInvalid = this.questionInvalid[this.question.id] ?? false
      if (questionInvalid) {
        return true
      }

      if (this.question.answered === true) {
        return false
      }

      return this.attributes.length === 0
    },
    customButton () {
      if (this.question.id === 'business_start_date') {
        return {
          disabled: false,
          name: this.question.id,
          btnText: 'I haven\'t started yet',
          clicked: this.customButtonClicked
        }
      }
      if (this.question.id === 'about_your_business') {
        return {
          disabled: false,
          name: this.question.id,
          btnText: 'None apply',
          clicked: this.customButtonClicked
        }
      }
      return null
    }
  },
  validations() {
    let validations
    if (this.question.alias === 'businessType') {
      validations = {
        value: {
          required: requiredIf(() => {
            return get(this.conditionalValidations, 'businessType.required')
          }),
        }
      }
    } else {
      validations = {
        value: { required: required }
      }
    }
    return {
      ...validations,
    }
  },
  methods: {
    onSubmit (question) {
      if (Object.keys(this.attributes).length > 0) {
        this.$emit('submit', this.attributes)
      } else {
        this.getNext()
      }
    },
    onAnswer ({ attr, submitImmediately, isInvalid }) {
      // Can't submit answers and update when already submitting
      if (this.submitting) {
        return
      }
      let attributes = cloneDeep(attr)
      this.questionInvalid[this.question.id] = isInvalid
      if (isInvalid) {
        return
      }

      if (attributes.constructor !== Array && typeof attributes === 'object') {
        this.attributes = [attributes]
      } else {
        this.attributes = attributes
      }

      if ((submitImmediately || this.singleForm) && Object.keys(this.attributes).length > 0) {
        this.$emit('submit', this.attributes)
      }
    },
    onCustomAction () {
      this.customButtonClicked = true
    },
    getPrevious () {
      this.$emit('previousQuestion')
    },
    getNext () {
      this.$emit('nextQuestion')
    },
    watchArrowKeys (e) {
      if (e.target && e.target.tagName && e.target.tagName.toUpperCase() === 'BODY') {
        const rightArrow = 39
        const leftArrow = 37
        if (e.keyCode === rightArrow && !this.disableNext) {
          this.getNext()
        } else if (e.keyCode === leftArrow && this.isNotFirstQuestion) {
          this.getPrevious()
        }
      }
    }
  },
  mounted () {
    this.mounted = true

    if (process.browser && !document.watchingArrowKeys) {
      document.watchingArrowKeys = true
      document.addEventListener('keydown', this.watchArrowKeys)
    }
    if (this.showSingleForm) {
      useQuestionsStore(this.$pinia).$patch({ singleForm: true })
    }
  },
  beforeUnmount () {
    if (process.browser && document.watchingArrowKeys) {
      document.watchingArrowKeys = false
      document.removeEventListener('keydown', this.watchArrowKeys)
    }
  },
  watch: {
    question: {
      // This cannot be an arrow function or it won't have reference to methods
      handler: function () {
        this.attributes = []
        // Deselect current active element to remove focused visual effect
        document.activeElement.blur()
        if(this.question?.attributes?.some(q => q.hasOwnProperty('value') && q.value !== undefined)) {
          this.attributes = this.question.attributes.slice()
        }
      },
    },
    submitting: {
      handler: function (newVal, oldVal) {
        if (oldVal === true && newVal === false) {
          this.customButtonClicked = false
        }
      }
    }
  },
  components: {
    BorrowerAttribute,
    QuestionNav
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.single-form {
  margin: 4px 0;
  .biq-name {
    margin-bottom: 12px;
  }
}
</style>
<style lang="scss">
.basic-info-attribute {
  .ba-label {
    margin-bottom: 12px;
  }
}
</style>
